<template>
  <ValidationProvider rules="required" slim v-slot="state" v-if="showSecondStep0and1 || showSecondStep2and3 || showSecondStep4and5">
    <div :class="validationState(state)" class="lib__field">
      <div class="lib__tiles lib__tiles--inline">
        <TileRadio :group="fieldId" :item="0" :label="$t('vatInfo.withDeclaration')" :description="$t('vatInfo.withDeclarationDescription')" no-uncheck v-if="showSecondStep0and1" v-model="selection">
        </TileRadio>
        <TileRadio :group="fieldId" :item="1" :label="$t('vatInfo.withoutDeclaration')" :description="$t('vatInfo.withoutDeclarationDescription')" no-uncheck v-if="showSecondStep0and1" v-model="selection">
        </TileRadio>
        <TileRadio :group="fieldId" :item="2" :label="$t('vatInfo.publicBuilding')" :description="$t('vatInfo.publicBuildingDescription')" no-uncheck v-if="showSecondStep2and3" v-model="selection">
        </TileRadio>
        <TileRadio :group="fieldId" :item="3" :label="$t('vatInfo.privateBuildingMoreThanTenYears')" :description="$t('vatInfo.privateBuildingMoreThanTenYearsDescription')" no-uncheck v-if="showSecondStep2and3" v-model="selection">
        </TileRadio>
        <TileRadio :group="fieldId" :item="4" :label="$t('vatInfo.privateBuildingLessThanTenYears')" :description="$t('vatInfo.privateBuildingLessThanTenYearsDescription')" no-uncheck v-if="showSecondStep2and3" v-model="selection">
        </TileRadio>
        <TileRadio :group="fieldId" :item="5" :label="$t('vatInfo.socialPrivateBuilding')" :description="$t('vatInfo.socialPrivateBuildingDescription')" no-uncheck v-if="showSecondStep4and5" v-model="selection">
        </TileRadio>
        <TileRadio :group="fieldId" :item="6" :label="$t('vatInfo.privateBuildingForDisabled')" :description="$t('vatInfo.privateBuildingForDisabledDescription')" no-uncheck v-if="showSecondStep4and5" v-model="selection">
        </TileRadio>
      </div>
      <error-message :error="state.errors[0]"></error-message>
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import { Component, Prop, Emit } from 'vue-property-decorator'
import { CompanyVatInfoFirstStepSelection, CompanyVatInfoSecondStepSelection } from '@/models'
import FieldBox from '@/components/inputs/Shared/FieldBox'

@Component({
  name: 'company-second-vat-info-selector'
})
export default class CompanySecondVatInfoSelector extends FieldBox {
  //#region [Property]
  @Prop({ type: Number, required: false }) public readonly firstSelection!: CompanyVatInfoFirstStepSelection | null
  @Prop({ type: Number, required: false }) public readonly value!: CompanyVatInfoSecondStepSelection | null
  //#endregion

  //#region [Computed]
  public get selection(): CompanyVatInfoSecondStepSelection | null {
    return this.value
  }

  public set selection(val: CompanyVatInfoSecondStepSelection | null) {
    this.change(val)
  }

  public get showSecondStep0and1() {
    return this.firstSelection === 0
  }

  public get showSecondStep2and3() {
    return this.firstSelection === 1 || this.firstSelection === 6
  }

  public get showSecondStep4and5() {
    return this.firstSelection === 2 || this.firstSelection === 4
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: CompanyVatInfoSecondStepSelection | null): CompanyVatInfoSecondStepSelection | null {
    return value
  }
  //#endregion
}
</script>